import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = [];

  for (let i = 1; i <= totalPages; i++) {
    pages.push(
      <button 
        key={i}
        onClick={() => onPageChange(i)}
        className={i === currentPage ? "button active" : "button"}
      >
        {i}
      </button>
    );
  }

  return (
    <div className="pagination">
      <button className="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Précédent
      </button>

      {pages}

      <button className="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Suivant
      </button>
    </div>
  );
};

export default Pagination;
